import DOMPurify from 'dompurify';

/**
 * Sanitiseur HTML centralisé pour les contenus injectés via dangerouslySetInnerHTML.
 *
 * Configuration : whitelist stricte de tags/attributs HTML pour les prévisualisations
 * de templates de notification (emails, SMS HTML-enrichis).
 *
 * CVE/CWE protégés : CWE-79 (Cross-Site Scripting).
 *
 * Usage :
 *   import { sanitizeHtml } from '../utils/sanitize';
 *   <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(untrustedHtml) }} />
 */

const DEFAULT_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'span', 'strong', 'em', 'u', 'b', 'i',
    'br', 'hr',
    'ul', 'ol', 'li',
    'a',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'blockquote', 'pre', 'code',
    'table', 'thead', 'tbody', 'tr', 'th', 'td',
    'img',
    'div',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style', 'alt', 'title', 'src', 'width', 'height'],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'button'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'formaction'],
  ALLOW_DATA_ATTR: false,
};

/**
 * Sanitise une chaîne HTML avant injection dans le DOM.
 * @param {string} dirty HTML potentiellement malveillant.
 * @param {object} overrides Overrides DOMPurify optionnels.
 * @returns {string} HTML sûr.
 */
export const sanitizeHtml = (dirty, overrides = {}) => {
  if (!dirty || typeof dirty !== 'string') return '';
  const config = { ...DEFAULT_CONFIG, ...overrides };
  return DOMPurify.sanitize(dirty, config);
};

export default sanitizeHtml;
